import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "vue";
import { orderBy } from "lodash";
import { DecoratedAsset } from "@/types";
import OutdoorUnit from "./OutdoorUnit.vue";
import { useLinkedAssets } from "@/composables/use-assets";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceDashboardTab',
  props: {
    asset: null
  },
  setup(__props: any) {

const props = __props as {
  asset: DecoratedAsset;
}



const { asset } = toRefs(props);

const { childAssets, loading } = useLinkedAssets(asset.value.assetUuid, {
  includeChildLinks: {
    filter: { linkType: "VRF_OU_IU" }
  }
});

const indoorUnits = computed(() => orderBy(childAssets.value, "properties.iu_unit_addr.value"));

return { __sfc: true,props, asset, childAssets, loading, indoorUnits, OutdoorUnit }
}

})